import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import StaticPostLayout from '../components/StaticPostLayout';
import InfoSection from '../components/TripInfo/chain-lakes-loop';
import MapSection from '../components/Maps/chain-lakes-loop';

class ChainLakesLoop extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Chain Lakes Loop Trail: The Most Scenic Hike Near Mount Baker</title>
          <meta name="description" content="Complete guide to the Chain Lakes Loop Trail near Mount Baker, Washington. Learn about the trailhead, parking, directions, backpacking, camping, and the best time to hike." />
          <meta property="og:title" content="Chain Lakes Loop Trail: The Most Scenic Hike Near Mount Baker" />
          <meta property="og:description" content="Complete guide to the Chain Lakes Loop Trail near Mount Baker, Washington. Trailhead, parking, directions, backpacking, camping, and best time to hike." />
          <meta property="og:url" content="https://exploroff.com/itineraries/chain-lakes-loop" />
          <meta property="og:type" content="article" />
          <meta property="og:image" content="https://exploroff.com/img/chain-lakes-loop/chain-lakes-loop.webp" />
          <link rel="canonical" href="https://exploroff.com/itineraries/chain-lakes-loop" />
          <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org", "@type": "BlogPosting",
            headline: "Chain Lakes Loop Trail: The Most Scenic Hike Near Mount Baker",
            description: "Complete guide to the Chain Lakes Loop Trail near Mount Baker, Washington.",
            image: ["https://exploroff.com/img/chain-lakes-loop/chain-lakes-loop.webp"],
            author: { "@type": "Organization", name: "ExplorOFF" },
            publisher: { "@type": "Organization", name: "ExplorOFF", logo: { "@type": "ImageObject", url: "https://exploroff.com/img/favicon.png" } },
            mainEntityOfPage: { "@type": "WebPage", "@id": "https://exploroff.com/itineraries/chain-lakes-loop" }
          })}</script>
        </Helmet>
        <MessengerCustomerChat pageId="101590111335192" appId="695593052231950" />
        <StaticPostLayout
          title="Chain Lakes Loop Trail"
          category="itineraries"
          slug="chain-lakes-loop"
          excerpt="The most scenic hike near Mount Baker, Washington. A 6.5-mile alpine loop through wildflower meadows and volcano views."
          tags={['trail tips', 'navigation', 'photography']}
          readTime={10}
          mapComponent={<MapSection />}
          whereToStay={[
            { name: 'Glacier Creek Motel', type: 'Motel · Glacier, WA', url: 'https://www.booking.com/searchresults.html?ss=Glacier%2C+Washington' },
            { name: 'Mt. Baker Lodging', type: 'Vacation Rentals · Maple Falls, WA', url: 'https://www.booking.com/searchresults.html?ss=Maple+Falls%2C+Washington' },
            { name: 'Hotels in Bellingham', type: 'Gateway City · 1 hr away', url: 'https://www.booking.com/searchresults.html?ss=Bellingham%2C+Washington' },
          ]}
        >
          <InfoSection />
        </StaticPostLayout>
      </>
    );
  }
}

export default ChainLakesLoop;
